import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RequestRialRoutingModule } from './request-rial-routing.module';
import { RequestRialCardComponent } from './request-rial-card/request-rial-card.component';
import { RequestRialComponent } from './request-rial.component';
import { SharedModule } from '@shared/shared.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RequestRialDetailComponent } from './request-rial-detail/request-rial-detail.component';


@NgModule({
  declarations: [ RequestRialComponent,RequestRialCardComponent, RequestRialDetailComponent],
  imports: [
    CommonModule,
    RequestRialRoutingModule,
    SharedModule,
    MatDatepickerModule,
  ],
 

})
export class RequestRialModule { }
